// extracted by mini-css-extract-plugin
export default {"wrapper":"iframe-module--wrapper--4f950","iframe":"iframe-module--iframe--10134","cookies":"iframe-module--cookies--65871"};